import { useRootData } from '@modules/root/hook/use-root-data';

/** Shown when a 503 reaches the catch boundary without a reason of its own. */
export const SERVICE_UNAVAILABLE_FALLBACK_MESSAGE =
    'One of our services had a problem processing your request';

interface ServiceUnavailableProps {
    /** The reason the loader attached to its 503, when it sent one. */
    message?: string;
}

/**
 * The 503 page: rendered between the navigation and the footer, like the
 * other catch pages, so the visitor keeps the site around the outage.
 */
const ServiceUnavailable = ({
    message = SERVICE_UNAVAILABLE_FALLBACK_MESSAGE,
}: ServiceUnavailableProps) => {
    const requestId = useRootData()?.requestId;

    return (
        <div className="w-full px-4.5 pt-15 pb-20 md:px-12.5 md:pt-51 md:pb-60">
            <h1 className="mb-5 text-8 leading-tight md:mb-10 md:font-display md:text-22.5 md:leading-normal">
                Temporarily unavailable
            </h1>
            <p className="text-4.5 md:text-9">
                {`${message}. Please try again in a moment.`}
            </p>
            {requestId ? (
                <p className="mt-4 text-sm">{`Request id: ${requestId}`}</p>
            ) : null}
        </div>
    );
};

export default ServiceUnavailable;
